export default [
	'init',
	'setProperty',
	'setProperties',
	'setState',
	'trigger'
];
